import type { Beat } from "../types";

/** Fraction (0..1) along the scrubber for a 1-based tick. */
export function tickFraction(tick: number, maxTick: number): number {
  if (maxTick <= 1) return 0;
  return (tick - 1) / (maxTick - 1);
}

/** Pixel x for a beat marker on a scrubber of the given width. */
export function beatMarkerX(tick: number, maxTick: number, width: number): number {
  return tickFraction(tick, maxTick) * width;
}

/** The 1-based tick for a click at `fraction` (0..1) along the scrubber. */
export function tickFromFraction(fraction: number, maxTick: number): number {
  if (maxTick < 1) return 0;
  const clamped = Math.max(0, Math.min(1, fraction));
  return 1 + Math.round(clamped * (maxTick - 1));
}

/** The latest beat at or before `tick`, or null. Beats are sorted by tick. */
export function latestBeatIndex(beats: Beat[], tick: number): number | null {
  let latest: number | null = null;
  for (let index = 0; index < beats.length; index++) {
    if (beats[index].tick <= tick) latest = index;
    else break;
  }
  return latest;
}
